import React from "react";

export const memberLoginHistoryColumns = () => [
  {
    key: "index",
    label: "S.No",
    width: "50px",
    sortable: false,
    render: (row, index, page, pageSize) => (page - 1) * pageSize + index + 1,
  },
  {
    key: "user_id",
    label: "Profile ID",
    width: "100px",
    sortable: false,
    render: (row) => row.user_id?.profile_id || "N/A",
  },
  {
    key: "user_name",
    label: "Name",
    width: "120px",
    sortable: false,
    render: (row) => row.user_id?.name || "N/A",
  },
  {
    key: "login_time",
    label: "Login Time",
    width: "150px",
    sortable: true,
    render: (row) =>
      new Date(row.login_time).toLocaleString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
  },
  {
    key: "logout_time",
    label: "Logout Time",
    width: "150px",
    sortable: false,
    render: (row) =>
      row.logout_time
        ? new Date(row.logout_time).toLocaleString("en-IN", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        : "Active",
  },
  // {
  //   key: "duration",
  //   label: "Duration (mins)",
  //   width: "120px",
  //   sortable: false,
  //   render: (row) => row.duration || "-",
  // },
  // {
  //   key: "device_type",
  //   label: "Device",
  //   width: "100px",
  //   sortable: false,
  //   render: (row) => (
  //     <span
  //       className="badge"
  //       style={{
  //         backgroundColor:
  //           row.device_type === "Mobile"
  //             ? "#3498db"
  //             : row.device_type === "Desktop"
  //             ? "#2ecc71"
  //             : "#e74c3c",
  //       }}
  //     >
  //       {row.device_type || "Unknown"}
  //     </span>
  //   ),
  // },
  // {
  //   key: "browser",
  //   label: "Browser",
  //   width: "100px",
  //   sortable: false,
  //   render: (row) => row.browser || "N/A",
  // },
  // {
  //   key: "os",
  //   label: "OS",
  //   width: "100px",
  //   sortable: false,
  //   render: (row) => row.os || "N/A",
  // },
  {
    key: "ip_address",
    label: "IP Address",
    width: "130px",
    sortable: false,
    render: (row) => row.ip_address || "N/A",
  },
  {
    key: "login_status",
    label: "Status",
    width: "90px",
    sortable: false,
    render: (row) => (
      <span
        className="badge"
        style={{
          backgroundColor: row.login_status === "success" ? "#27ae60" : "#c0392b",
        }}
      >
        {row.login_status?.charAt(0).toUpperCase() + row.login_status?.slice(1)}
      </span>
    ),
  },
];
